import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { RootState } from '../../../store';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../../main/left-side';
import TitleCard from '../../main/title-card';
import Card from '../../main/card';
import useTranslate from '../../useTranslate';
import {
    LoadAllLocationsForAccountingArea,
    LocationOverviewDto,
} from '../../../store/locationsSlice';
import { LoadMansions, Mansion } from '../../../store/mansionsSlice';
import Navbar from '../../navigation/navbar';
import { RequestStatus } from '../../../store/network/managedRequest';
import SelectLocationTable, {
    LocationAndMansion,
} from './select-location-table';
import { PbRequest } from '../../../store/pbRequest';
import { useNavigate } from 'react-router-dom';

interface Props {
    locations: LocationOverviewDto[];
    locationsRequestStatus: RequestStatus;
    mansions: { [key: string]: Mansion };
    LoadAllLocationsForAccountingArea: () => void;
    LoadMansions: () => void;
}

function SelectLocationPricingScreen(props: Readonly<Props>) {
    const navigate = useNavigate();

    useEffect(() => {
        props.LoadAllLocationsForAccountingArea();
        props.LoadMansions();
    }, []);

    useEffect(() => {
        if (props.locationsRequestStatus !== RequestStatus.SUCCESS) {
            return;
        }
        if (props.locations?.length === 1) {
            const { id, mansion_id } = props.locations[0];
            navigate(`/objects/${mansion_id}/${id}/pricing`, { replace: true });
        }
    }, [props.locations, props.locationsRequestStatus]);

    const strings = useTranslate('SelectLocationPricing');

    function renderTable() {
        if (!props.locations) {
            return null;
        }

        const list: LocationAndMansion[] = props.locations.map((location) => ({
            location,
            mansion: props.mansions[location.mansion_id],
            targetLink: {
                pathname: `/objects/${location.mansion_id}/${location.id}/pricing`,
            },
        }));

        return <SelectLocationTable locationsWithMansion={list} />;
    }

    return (
        <Navbar nav>
            <Row>
                <LeftSide addClass="">
                    <TitleCard
                        title={strings.priceTitle}
                        left={{
                            content: (
                                <Link
                                    to={`/dashboard`}
                                    className="icon icon-wew-arrow-left icon-sm"
                                />
                            ),
                            title: strings.priceTitle,
                        }}
                    />
                </LeftSide>
                <Col xs={9} className="col-middle">
                    <Card title={strings.title}>
                        <p>{strings.description}</p>
                        {renderTable()}
                    </Card>
                </Col>
            </Row>
        </Navbar>
    );
}

export default connect(
    (store: RootState) => ({
        locations: store.locations.allLocationsForAccountingArea,
        locationsRequestStatus:
            store.pbRequest[PbRequest.GET_ALL_LOCATIONS_FOR_ACCOUNTING_AREA]
                .status,
        mansions: store.mansions.mansionsById,
    }),
    { LoadAllLocationsForAccountingArea, LoadMansions }
)(SelectLocationPricingScreen);
